import { IconActionList16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { trackShowAllClick } from './tracking';
import { ChatbotButton } from '../../components/ChatbotButton';

export const ShowAllButtonContainer: React.FC = () => {
  const onClick = React.useCallback(() => {
    trackShowAllClick();
    window.open(`/recommendations/`, '_blank');
  }, []);

  return (
    <ChatbotButton
      theme="fill_white_primary"
      beforeIcon={<IconActionList16 color="icon-main-default" />}
      onClick={onClick}
    >
      Посмотреть все
    </ChatbotButton>
  );
};
